<template>
  <div class="indexCont">
    <div class="mainCont">
      <div class="btnArr">
        <el-button size="small" @click="goPage('./test')">
          待考试({{$config.waitTest}})
        </el-button>
        <el-button type="danger" size="small">
          已考试({{dataInfo.total}})
        </el-button>
      </div>
      <div class="testCont">
        <el-table
          :data="dataList"
          stripe
          style="width: 100%"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column align="center" label="序号" type="index"></el-table-column>
          <el-table-column prop="paperName" align="center" label="试卷名称"></el-table-column>
          <el-table-column prop="parentCategoryName" align="center" label="试卷类型"></el-table-column>
          <el-table-column prop="categoryName" align="center" label="考试科目"></el-table-column>
          <el-table-column prop="lastTime" align="center" label="考试时间"></el-table-column>
          <el-table-column prop="limitTime" align="center" label="考试时长"></el-table-column>
          <el-table-column prop="lastScore" align="center" label="考试得分"></el-table-column>
          <el-table-column prop="ranking" align="center" label="考试排名"></el-table-column>
          <el-table-column prop="useCount" align="center" label="考试次数"></el-table-column>
          <el-table-column align="center" label="操作" width="210">
            <template slot-scope="scope">
              <!-- scope.row：代表这一行数据的对象 -->
              <span class="testDetail" 
                @click="goPage('./testDetail?paperHistoryId=' + scope.row.lastPaperHistoryId + '&curPage=' + curPage)">
               考试详情
              </span>
              <span class="testDetail" @click="goPage('./goTest?companyId='+ scope.row.companyId +'&paperId=' + scope.row.paperId + '&url=alreadyTest' + '&curPage=' + curPage)">去考试</span>
              <span class="testDetail" v-show="scope.row.certStatus" @click="downloadCert(scope.row.certVo)">
                考试证书
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination background layout="prev, pager, next" :total="dataInfo.total" @current-change="changePage" ref="pagination"></el-pagination>
      </div>
    </div>
      <!-- 移动端显示 -->
    <div class="mobileTest">
      <MobileComNav title="我的考试" url="./index"></MobileComNav>
      <div class="switchTest">
        <div @click="goPage('./test')">待考科目</div>
        <div class="active">已考科目</div>
      </div>
      <div class="mt_cont">
        <div class="mt_item" v-for="(item,index) in dataList" :key="index">
          <div class="title">{{item.paperName}}</div>
          <div class="time">考试时间：{{item.lastTime}}</div>
          <div class="status">考试得分：<span class="addColor">{{item.lastScore}}</span></div>
          <div class="">考试排名：<span class="addColor">{{item.ranking}}</span></div>
          <div v-show="item.certStatus" @click="downloadCert(item.certVo)" class="mobileDown">证书下载</div>
          <div class="btn2">
            <span @click="goPage('./goTest?companyId='+ item.companyId +'&paperId=' + item.paperId + '&url=alreadyTest')">去考试</span>
            <span @click="goPage('./testDetail?paperHistoryId=' + item.lastPaperHistoryId)">考试结果</span>
            <!-- <span @click="centerDialogVisible = true">删除试卷</span> -->
          </div>
        </div>
      </div>
      <div class="comTxt" v-show="isShow">暂无数据</div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        :width="dialogWidth"
        center>
        <span>是否确定删除试卷</span>
        <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleItem">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 证书 -->
    <el-dialog
        :visible.sync="DialogVisibleCert"
        :width="certDialogWidth"
        :close-on-press-escape="false"
        center>
        <div class="certPic">
            <img src="../../../assets/images/common/certPic.jpg" alt="" v-if="isShowCetrtPic">
            <img :src="$config.baseApi + certPic" alt="" v-else>
            <!-- <div class="cert_txt">
                <div class="username">{{username}}</div>
                <div class="certCode">编号No：{{certCode}}</div>
                <div class="time">日期Date：{{certTime}}</div>
            </div> -->
        </div>
    </el-dialog>
  </div>
</template>

<script>
import MobileComNav from "../../../components/mobileHead";
import getQuery from "../../../assets/js/libs/getQuery.js";
export default {
  data() {
    return {
      dialogWidth: "80%",
      centerDialogVisible: false,
      curPage: 1,
      loading: true,
      dataInfo:{},
      dataList:[],
      pageSize:10,
      username:"",
      certCode:"",
      certTime:"",
      certPic:"",
      isShowCetrtPic:true,
      DialogVisibleCert:false,
      certDialogWidth:"5rem",
      isShow:false,
    };
  },
  components: {
    MobileComNav
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  created() {
    if(this.$IsPc()){
      this.pageSize = 10000 ;
      this.certDialogWidth = "6rem"
    };
    if(window.location.href.indexOf('curPage') > -1){
      this.curPage = getQuery('curPage')
    }
    //动态改变页码上的分页
    this.$nextTick(() => {
        this.$refs.pagination.internalCurrentPage = Number(this.curPage);
    })
    this.paperList();
  },
  methods: {
    goPage(url){
        this.$router.push(url);
    },
    deleItem(){
      this.centerDialogVisible = false;
      alert("成功")
    },
    // 已考列表
    paperList() {
      let url = this.$config.baseApi + "/examination/paper/history/list";
      this.$ajax({
        url: url,
        method: "post",
        data: JSON.stringify({
          useFlag:1, //1为已考
          current:this.curPage,
          pageSize:this.pageSize
        })
      })
        .then(res => {
          if (res.code == 1) {
            if(res.data.total == 0){
              this.isShow = true
            }
            this.dataList = res.data.records;
            this.dataInfo = res.data;
            this.loading = false;
            this.$config.alreadyTest = res.data.total
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分页改变
    changePage(pageIndex){
        this.curPage = pageIndex;
        this.paperList();
    },
    // 证书下载
    downloadCert(certVo){
      this.DialogVisibleCert=true,
      this.username = certVo.username;
      this.certCode = certVo.certCode;
      this.certTime = certVo.createTime.slice(0,10);
      let certPic = certVo.certPic;
      if(certPic){
        this.certPic = certPic;
        this.isShowCetrtPic = false;
      }
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/home/test.css";
.mainCont {
  background: #fff;
  padding: 0.23rem 0.2rem;
  margin-bottom: 0.2rem;
}
@media screen and (max-width: 768px) {
  .mainCont {
    display: none;
  }
  .mobileTest {
    display: block;
  }
  .mobileDown{
    position: absolute;
    top:0.1rem;
    right:0.1rem;
    background: rgba(56, 124, 205, 1);
    font-size:0.24rem;
    color:#fff;
    padding:0.01rem 0.2rem;
    border-radius:0.3rem ;
  }
}
</style>
